<script setup lang="ts">
/**
 * creating an adaptive navbar
 *
 */

import '@/assets/styles/navbar.css';
</script>

<template>
  <div class="navbar">
    <div class="navbar-header">
      <h1>Gallus Pflegedienst e.K.</h1>
    </div>
    <nav class="stones">
      <router-link to="/" class="stones-link">Home</router-link>
      <router-link to="/about" class="stones-link">Über Uns</router-link>
      <router-link to="/services" class="stones-link">Dienstleistungen</router-link>
      <router-link to="/career" class="stones-link">Karriere</router-link>
      <router-link to="/contact" class="stones-link">Kontakt</router-link>
    </nav>
  </div>
</template>

<style scoped>
</style>